const createProgram = ({
  name,
  location,
  type,
  sourceUrl,
  overview,
  credential,
  format,
  length,
  tuition,
  admissions,
  focus,
  highlights,
  mapEmbedUrl,
}) => ({
  name,
  location,
  type,
  credential,
  format,
  length,
  tuition,
  admissions,
  summary: overview,
  badge: type,
  websiteUrl: sourceUrl,
  sourceUrl,
  specs: [
    ['Program type', type],
    ['Credential', credential],
    ['Class format', format],
    ['Program length', length],
    ['Tuition and fees', tuition],
    ['Admissions and requirements', admissions],
  ],
  paragraphs: [
    focus,
    'Program length, tuition, prerequisites, clinical requirements, application deadlines, and cohort availability can change. Confirm all current details directly with the institution before applying.',
  ],
  highlights,
  address: location,
  mapEmbedUrl,
});

export const programs = [
  createProgram({
    name: 'Collin College Physical Therapist Assistant Program',
    location: '3452 Spur 399, McKinney, TX 75069',
    type: 'Public community college PTA program',
    sourceUrl: 'https://www.collin.edu/academics/programs/physical-therapist-assistant/',
    mapEmbedUrl: 'https://www.google.com/maps?q=Collin+College+Physical+Therapist+Assistant+Program+McKinney+TX&output=embed',
    overview: 'Collin College offers a physical therapist assistant pathway that combines health science foundations, technical PTA instruction, laboratory practice, and supervised clinical education.',
    credential: 'Associate of Applied Science (AAS)',
    format: 'Campus instruction, laboratory practice, and supervised clinical education',
    length: '2 years across 6 semesters',
    tuition: 'Estimated total: about $6,907 in-district, $11,317 for Texas residents outside Collin County, or $15,817 for out-of-state and international students. Estimates include tuition, lab fees, books, and compliance tracking.',
    admissions: 'Prerequisites include BIOL 2401 Anatomy and Physiology I, ENGL 1301, and PTHA 1409 Introduction to Physical Therapy. Verify current application and health documentation requirements.',
    focus: 'The program includes a comprehensive exam at the end of the second semester. Collin College reports a 100% first-time licensure pass rate and employment rate; verify the latest outcomes directly with the college.',
    highlights: [
      'McKinney public-college PTA pathway',
      'AAS degree completed across 6 semesters',
      'Prerequisites include BIOL 2401, ENGL 1301, and PTHA 1409',
      'Reported 100% first-time licensure pass rate and employment rate',
    ],
  }),
  createProgram({
    name: 'Concorde Career College Physical Therapist Assistant Program',
    location: '12606 Greenville Avenue, Dallas, TX 75243',
    type: 'Private career college PTA program',
    sourceUrl: 'https://www.concorde.edu/programs/physical-therapist-assistant/',
    mapEmbedUrl: 'https://www.google.com/maps?q=Concorde+Career+College+Dallas+TX&output=embed',
    overview: 'Concorde Career College provides a fast-paced physical therapist assistant pathway with classroom and online theory, hands-on laboratory training, and clinical externships in multiple healthcare settings.',
    credential: 'Associate of Applied Science (AAS)',
    format: 'Online and classroom theory, laboratory practice, and clinical externships',
    length: 'Approximately 20 months',
    tuition: 'Program-specific tuition is customized through the current catalog and financial planning process. Private career college pricing is generally higher than public community college pricing.',
    admissions: 'Review current admissions, prerequisite, health documentation, background-check, and financial-planning requirements with the Dallas campus.',
    focus: 'The program includes 78 total credit hours, 360 hours of hands-on lab work, and 720 hours of clinical externships across settings such as outpatient orthopedics, acute care, and skilled nursing.',
    highlights: [
      'Dallas-based fast-paced PTA education',
      '78 total credit hours',
      '360 laboratory hours and 720 clinical externship hours',
      'Clinical settings may include outpatient orthopedics, acute care, and skilled nursing',
    ],
  }),
  createProgram({
    name: 'Tarrant County College District Physical Therapist Assistant Program',
    location: '300 Trinity Campus Circle, Fort Worth, TX 76102',
    type: 'Public community college PTA program',
    sourceUrl: 'https://www.tccd.edu/programs/physical-therapist-assistant/',
    mapEmbedUrl: 'https://www.google.com/maps?q=Tarrant+County+College+Trinity+River+Campus+Fort+Worth+TX&output=embed',
    overview: 'Tarrant County College District offers a public-college PTA pathway through the TCC Trinity River Campus, with classroom, laboratory, and clinical preparation for patient-care practice.',
    credential: 'Associate of Applied Science (AAS) in Physical Therapy',
    format: 'Classroom instruction, hands-on laboratory work, and clinical education',
    length: '2 years across 5 consecutive semesters',
    tuition: 'In-county tuition is approximately $1,970 to $2,510 per first-year semester, including standard tuition, books, and basic fees. Out-of-county Texas residents pay an additional $62 per semester hour. Other expenses include about $140 for background and drug screening and approximately $650 for the national board exam.',
    admissions: 'The program includes 63 total credit hours. Confirm current prerequisite, application, compliance tracking, immunization, background-check, and clinical travel requirements.',
    focus: 'TCC includes rigorous clinical practice and requires students to maintain compliance documentation, immunizations, and readiness for travel to clinical sites.',
    highlights: [
      'TCC Trinity River Campus in Fort Worth',
      '63 total credit hours across 5 consecutive semesters',
      'AAS in Physical Therapy',
      'Clinical compliance, immunizations, and travel may be required',
    ],
  }),
  createProgram({
    name: 'Weatherford College Physical Therapist Assistant Program',
    location: '225 College Park Drive, Weatherford, TX 76086',
    type: 'Public community college PTA program',
    sourceUrl: 'https://www.wc.edu/programs/physical-therapist-assistant/',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3355.9208662094074!2d-97.79257559999999!3d32.7412919!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8651fdfb8ac942b5%3A0xa6afccce1d14c43d!2sWeatherford%20College!5e0!3m2!1sen!2smx!4v1790371694353!5m2!1sen!2smx',
    overview: 'Weatherford College offers a physical therapist assistant pathway for students seeking public-college education west of the Dallas-Fort Worth metroplex.',
    credential: 'Associate of Applied Science (AAS)',
    format: 'College coursework, laboratory practice, and supervised clinical education',
    length: '21 months',
    tuition: 'Standard tuition rates include a specialized differential tuition fee of $60 per credit hour for technical PTHA courses. Estimated annual public tuition is about $7,830 in-district or $12,090 out-of-district, with approximately $4,100 in additional program expenses for technical fees, books, and equipment.',
    admissions: 'General education courses must be planned into the pathway. Completing general education courses early does not shorten the strict 21-month technical sequence. Verify current admissions and health requirements.',
    focus: 'Weatherford College may suit students who live west of DFW or prefer a community-college setting. Compare the full cost of attendance, clinical schedule, transportation needs, and technical course sequence.',
    highlights: [
      'Weatherford public-college PTA pathway',
      '21-month technical sequence',
      'Technical PTHA courses include a $60-per-credit-hour differential',
      'General education completion does not shorten the technical sequence',
    ],
  }),
  createProgram({
    name: 'Northeast Texas Community College Physical Therapist Assistant Program',
    location: '2886 FM 1735, Mount Pleasant, TX 75455',
    type: 'Public community college PTA program',
    sourceUrl: 'https://www.ntcc.edu/programs/physical-therapist-assistant',
    mapEmbedUrl: 'https://www.google.com/maps?q=Northeast+Texas+Community+College+Mount+Pleasant+TX&output=embed',
    overview: 'Northeast Texas Community College provides a physical therapist assistant pathway serving the outer northeast Dallas-Fort Worth perimeter and East Texas region.',
    credential: 'Associate Degree of Applied Science (AAS)',
    format: 'Community college coursework, laboratory instruction, and clinical education',
    length: '2 years',
    tuition: 'Standard NTCC community college tuition rates apply. In-state tuition typically averages about $4,500 to $5,000 per year, plus health science program fees, textbooks, and clinical tracking materials.',
    admissions: 'Review current prerequisites, application materials, health requirements, compliance documentation, and clinical placement expectations with NTCC.',
    focus: 'Graduates are eligible to sit for the PTA licensure examination administered through the Texas Executive Council of Physical Therapy and Occupational Therapy Examiners. Confirm current eligibility requirements before applying.',
    highlights: [
      'Mount Pleasant option serving East Texas and northeast DFW',
      'AAS pathway completed in approximately 2 years',
      'Estimated in-state tuition of about $4,500 to $5,000 per year before program expenses',
      'Graduates are eligible to pursue the Texas PTA licensure examination',
    ],
  }),
  createProgram({
    name: 'University of Texas at Arlington Certified Physical Therapy Aide Program',
    location: 'Arlington, TX',
    type: 'University continuing education physical therapy aide program',
    sourceUrl: 'https://www.uta.edu/academics/continuing-education',
    mapEmbedUrl: 'https://www.google.com/maps?q=University+of+Texas+at+Arlington+Arlington+TX&output=embed',
    overview: 'The University of Texas at Arlington Certified Physical Therapy Aide program offers a streamlined pathway for students interested in entry-level physical therapy support roles and clinical office environments.',
    credential: 'AMCA Physical Therapy Technician/Aide Certification preparation',
    format: 'Self-paced online curriculum with career development modules',
    length: '202 hours completed across 9 months',
    tuition: '$2,599, with flexible payment options including Affirm and TuitionFlex',
    admissions: 'Review current enrollment requirements, course access details, certification eligibility, exam policies, and payment terms directly with the University of Texas at Arlington before enrolling.',
    focus: 'The 26-module curriculum covers medical terminology, human anatomy, patient transfers, therapeutic modalities, medical administration, and career development. Tuition includes an AMCA Physical Therapy Technician/Aide Certification exam voucher. Confirm current certification and employment-outlook details with UTA and the relevant certification organization.',
    highlights: [
      'Self-paced online program through the University of Texas at Arlington',
      '202-hour curriculum completed across 9 months',
      '26 modules covering anatomy, transfers, therapeutic modalities, and medical administration',
      '$2,599 tuition with Affirm and TuitionFlex payment options',
      'Includes an AMCA Physical Therapy Technician/Aide Certification exam voucher',
    ],
  }),
  createProgram({
    name: 'Ed2Go Certified Physical Therapy Aide Program',
    location: 'Online',
    type: 'Online continuing education physical therapy aide program',
    sourceUrl: 'https://www.ed2go.com/online-courses/physical-therapy-aide/',
    mapEmbedUrl: 'https://www.google.com/maps?q=Ed2Go+Certified+Physical+Therapy+Aide+Program&output=embed',
    overview: 'The Ed2Go Certified Physical Therapy Aide program provides a comprehensive, self-paced online pathway for students preparing for entry-level clinical support roles in physical therapy settings.',
    credential: 'AMCA Physical Therapy Technician/Aide Certification preparation',
    format: 'Self-paced online curriculum with shipped textbooks and exam preparation',
    length: '202 course hours with 9 months of access',
    tuition: '$2,499, with flexible installment options including Affirm',
    admissions: 'Review the current enrollment requirements, course access terms, textbook delivery details, certification eligibility, exam policies, and payment options directly with Ed2Go before enrolling.',
    focus: 'The curriculum covers medical terminology, human anatomy, patient transfer techniques, and therapeutic modality protocols. Tuition includes shipped core textbooks, including Pierson and Fairchild’s Principles & Techniques of Patient Care, along with an official exam voucher for the American Medical Certification Association Physical Therapy Technician/Aide Certification (PTTC). Confirm current certification, employment-outlook, and annual-opening information with Ed2Go and AMCA.',
    highlights: [
      'Self-paced online program through Ed2Go',
      '202 intensive course hours with 9 months of access',
      '$2,499 tuition with installment options including Affirm',
      'Includes shipped core textbooks, including Pierson and Fairchild’s Principles & Techniques of Patient Care',
      'Includes an AMCA Physical Therapy Technician/Aide Certification exam voucher',
    ],
  }),
];

export const resources = [
  {
    title: 'American Physical Therapy Association',
    description: 'Explore physical therapy education, professional standards, advocacy, and career resources.',
    url: 'https://www.apta.org/',
  },
  {
    title: 'Federation of State Boards of Physical Therapy',
    description: 'Review physical therapist assistant licensure and National Physical Therapy Examination resources.',
    url: 'https://www.fsbpt.org/',
  },
  {
    title: 'Texas Board of Physical Therapy Examiners',
    description: 'Find Texas licensing, renewal, rules, and practice information for PTAs.',
    url: 'https://ptot.texas.gov/',
  },
];